module.exports = __webpack_public_path__ + "static/r10-a432db1ec2a44feb8623fb40d094759c.jpg";